import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Login from "@/views/Login.vue";
import {auth} from "@/services/Auth";
import configurationRoutes from "@/router/configuration";
import crmRoutes from "@/router/crm";
import incomeRoutes from "@/router/income";
import errorRoutes from "@/router/error";
import comparatorRoutes from "@/router/comparator";
import adminRoutes from "./admin";
import partnerRoutes from "./partner";
import PartnerLogin from "@/views/Partner/PartnerLogin.vue";
import ManagerLogin from "@/views/ManagerLogin.vue";
import prospectionRoutes from "./prospection";
import chatRoutes from "@/router/chat";
import accountingRoutes from "@/router/accounting";
import wicare from "@/views/wicare.vue";
import wicareRoutes from "@/router/wicare";
import TenantSelector from "@/views/TenantSelector.vue";
import crmv2Routes from "@/router/crmv2";
import {registerRouteRoles} from "@/router/Menu";

Vue.use(VueRouter);
const defaultRoutes: Array<RouteConfig> = [
  {
    path: "/",
    name: "home",
    component: Home,
  },

  {
    path: "/tenant-selector",
    name: "tenant-selector",
    component: TenantSelector,
  },

  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/partner/login",
    name: "partner-login",
    component: PartnerLogin,
  },
  {
    path: "/manager/login",
    name: "manager-login",
    component: ManagerLogin,
  },
  {
    path: "/logout",
    name: "logout",
    beforeEnter() {
      auth.logout();
    },
  },
  // {
  //     path: '/config',
  //     name: 'config',
  //     component: Config,
  //     meta: {requiredRoles: ['ROLE_USER']},
  // },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Home,
    meta: {requiredRoles: ['ROLE_PRODUCTEUR', 'ROLE_PARTNER', 'ROLE_COMMERCIAL', 'ROLE_COMPTABILITE']},
  },
  {
    path: "/production/dashboard",
    name: "production-dashboard",
    component: () => import("@/views/Monitoring/ProductionDashboard.vue"),
    meta: { requiredRoles: ["ROLE_MANAGER"] },
  },
  {
    path: "/monitoring/renewals",
    name: "renewal-dashboard",
    component: () => import("@/views/Monitoring/RenewalDashboard.vue"),
    meta: { requiredRoles: ["ROLE_MANAGER"] },
  },
  {
    path: "/monitoring/ai",
    name: "ai-conversations",
    component: () => import("@/views/Monitoring/AiConversations.vue"),
    meta: { requiredRoles: ["ROLE_ADMIN"] },
  },
  {
    path: "/monitoring/system",
    name: "system-health",
    component: () => import("@/views/Monitoring/SystemHealth.vue"),
    meta: { requiredRoles: ["ROLE_ADMIN"] },
  },
  {
    path: "/monitoring/activity",
    name: "activity-log",
    component: () => import("@/views/Monitoring/ActivityLog.vue"),
    meta: { requiredRoles: ["ROLE_MANAGER"] },
  },
  {
    path: "/monitoring/access-denied",
    name: "access-denied-log",
    component: () => import("@/views/Monitoring/AccessDeniedLog.vue"),
    meta: { requiredRoles: ["ROLE_ADMIN"] },
  },
  {
    path: "/daily-report",
    name: "daily-report",
    component: () => import("@/views/DailyReport/DailyReportDashboard.vue"),
    meta: { requiredRoles: ["ROLE_MANAGER", "ROLE_PRODUCTEUR"] },
  },
  {
    path: "/daily-report/input",
    name: "daily-report-input",
    component: () => import("@/views/DailyReport/DailyReportInput.vue"),
    meta: { requiredRoles: ["ROLE_COMMERCIAL", "ROLE_PARTNER", "ROLE_MANAGER"] },
  },
  // Ancienne vue WhatsApp (ChatIndex) archivee : conservee tant que ses features
  // (onglets, documents, notes, actions supplementaires, filtres partner/contain)
  // ne sont pas portees sur la nouvelle console (/crm/chat-whatsapp).
  {
    path: "/old/crm/chat-whatsapp",
    name: "chat-whatsapp-old",
    component: () => import("@/views/Chat/ChatIndex.vue"),
    props: (route: any) => ({
      ...route.query,
    }),
    meta: { requiredRoles: ["ROLE_COMMERCIAL", "ROLE_MANAGER"] },
  },
];

let base = "/";
let routes = defaultRoutes
  .concat(configurationRoutes)
  .concat(incomeRoutes)
  //   .concat(communicationRoutes)
  .concat(errorRoutes)
  .concat(comparatorRoutes)
  .concat(adminRoutes)
  .concat(partnerRoutes)
  .concat(accountingRoutes)
  //   .concat(prospectionRoutes)
  .concat(chatRoutes)
  .concat(wicareRoutes)
  .concat(crmRoutes);
// .concat(crmv2Routes);

const host = window.location.host;
const parts = host.split(".");
const domainLength = 3;
// console.log(parts)
if (parts[0] === "comparateur" || parts[0] === "comparer") {
  for (let route of comparatorRoutes) {
    route.path = route.path.replace("/comparateur", "");
  }
  routes = comparatorRoutes;
}
// console.log(routes)
// console.log(base)
// if (parts.length === (domainLength - 1) || parts[0] === 'www') {
//     routes = index;
// } else if (parts[0] === 'route1') {
//     routes = route1;
// } else if (parts[0] === 'route2') {
//     routes = route2;
// } else {
//     // If you want to do something else just comment the line below
//     routes = index;
// }

// Source de verite unique pour les roles : meta.requiredRoles des routes.
// Construit l'index name -> requiredRoles et re-injecte les roles dans les entrees de Menu.ts.
registerRouteRoles(routes);

const router = new VueRouter({
  mode: "history",
  base: base,
  routes,
});

export default router;
